module.exports = __webpack_public_path__ + "static/media/medisin.3a7ae67c.m4a";